import { render, staticRenderFns } from "./ConsultaNotaNacional.vue?vue&type=template&id=3b458126&scoped=true&"
import script from "./ConsultaNotaNacional.vue?vue&type=script&lang=js&"
export * from "./ConsultaNotaNacional.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaNotaNacional.vue?vue&type=style&index=0&id=3b458126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b458126",
  null
  
)

export default component.exports